if (typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");
var lib_core = require("lib-core");

var SnapLineType = require("./../../snap/snapLineType.js");
var SnapSet = require("./../../snap/snapSet.js");
var cio_config = require("cio-config");

var LineHandleModel = require("./lineHandleModel.js");
var AbstractSelectableInteractionModel = require("../../../abstract/abstractSelectableInteractionModel.js");

var LineInteractionModel = function (lineData, editorModel, options) {
    AbstractSelectableInteractionModel.call(this, lineData);

    this.editorModel = editorModel;
    this.origin = editorModel.origin();
    this.options = options || {};

    this.boundingBox = this.data.boundingBox;

    // these used to halt infinite loop caused by model/handle update
    // these specifically must be functions accessible from outside, so
    // we can set these on other handles in the grid at upper level
    this.noUpdateModel = this.value("noUpdateModel", true);
    this.noUpdateHandle = this.value("noUpdateHandle", true);

    // used for alt/center mode, need to keep track of shape position when mousedown on handle
    this.sessionCoord = this.value("sessionCoord", true);

    // 3 handles
    this.handles = this.list("handles", true);
    this.handles.add(0, new LineHandleModel(lineData, 1, this));
    this.handles.add(1, new LineHandleModel(lineData, 2, this));
    this.handles.add(2, new LineHandleModel(lineData, 3, this));
    this.updateAllHandles();

    this.showLength = this.shadow("showLength",
        function () {
            return this.data.length() / this.origin.getGridFactor();
        },
        function (val) {
            return this.data.length(val * this.origin.getGridFactor());
        },
        [this.data.length, this.origin.grid_unit]
    );

    this.showX1 = this.shadow("showX1",
        function () {
            return this.data.x1() / this.origin.getGridFactor();
        },
        function (coord) {
            return this.data.x1(coord * this.origin.getGridFactor());
        },
        [this.data.x1, this.origin.grid_unit]
    );

    this.showX2 = this.shadow("showX2",
        function () {
            return this.data.x2() / this.origin.getGridFactor();
        },
        function (coord) {
            return this.data.x2(coord * this.origin.getGridFactor());
        },
        [this.data.x2, this.origin.grid_unit]
    );

    this.showY1 = this.shadow("showY1",
        function () {
            return this.data.y1() / this.origin.getGridFactor();
        },
        function (coord) {
            return this.data.y1(coord * this.origin.getGridFactor());
        },
        [this.data.y1, this.origin.grid_unit]
    );

    this.showY2 = this.shadow("showY2",
        function () {
            return this.data.y2() / this.origin.getGridFactor();
        },
        function (coord) {
            return this.data.y2(coord * this.origin.getGridFactor());
        },
        [this.data.y2, this.origin.grid_unit]
    );

    this.showStrokeWidth = this.shadow("showStrokeWidth",
        function () {
            return this.data.strokeWidth() / this.origin.getGridFactor();
        },
        function (strokeWidth) {
            return this.data.strokeWidth(Math.abs(strokeWidth || 0) * this.origin.getGridFactor());
        },
        [this.data.strokeWidth, this.origin.grid_unit]
    );
};

lib_core.inherit(LineInteractionModel, AbstractSelectableInteractionModel);
lib_core.JsonParser.registerClass(LineInteractionModel, "LineInteractionModel");

module.exports = LineInteractionModel;

LineInteractionModel.prototype.updateAllHandles = function () {
    this.handles.forEach(function (idx, obj) {
        obj.updateHandleNoModel();
    });
};

LineInteractionModel.prototype.updateSessionPos = function() {
    this.sessionCoord(this.data.pos());
};

LineInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = {};

    inspectorElements.input_elements = [
        {
            label: 'Length',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showLength,
            datatype    : cio_config.types.positive_float,
            unitmember : this.origin.showUnitString
        },
        {
            label: 'x1',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showX1,
            datatype    : cio_config.types.float,
            unitmember : this.origin.showUnitString
        },
        {
            label: 'y1',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showY1,
            datatype    : cio_config.types.float,
            unitmember : this.origin.showUnitString
        },
        {
            label: 'x2',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showX2,
            datatype    : cio_config.types.float,
            unitmember : this.origin.showUnitString
        },
        {
            label: 'y2',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showY2,
            datatype    : cio_config.types.float,
            unitmember : this.origin.showUnitString
        },
        {
            label: 'Stroke Width',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showStrokeWidth,
            datatype    : cio_config.types.positive_float,
            unitmember : this.origin.showUnitString
        }
    ];

    inspectorElements.help_elements = {
        'name': 'Line'
    };

    return inspectorElements;
};

LineInteractionModel.prototype.getSnapSet = function (type) {
    var snapSet = new SnapSet();

    switch(type) {
        case SnapLineType.TO:
            snapSet.addHor(this.data.p1(), 1, 0, null, this, 0, null);
            snapSet.addVer(this.data.p1(), 1, 0, null, this, 0, null);
            snapSet.addHor(this.data.p2(), 1, 0, null, this, 0, null);
            snapSet.addVer(this.data.p2(), 1, 0, null, this, 0, null);
            break;
        case SnapLineType.FROM:
            snapSet.add(this.data.p1(), 1, 0, null, this, 0, null);
            snapSet.add(this.data.p2(), 1, 0, null, this, 0, null);
            break;
    }

    return snapSet;
};

LineInteractionModel.prototype.rotate = function() {
    return this.data.rotate.apply(this.data, arguments);
};

LineInteractionModel.prototype.pos = function() {
    return this.data.pos.apply(this.data, arguments);
};

LineInteractionModel.prototype.height = function(newHeight) {
    if(newHeight !== null && newHeight !== undefined && newHeight < 1e-6)
        newHeight = this.data.height() === 0 ? this.data.height() : 1;
    return this.data.height.call(this.data, newHeight);
};

LineInteractionModel.prototype.width = function(newWidth) {
    if(newWidth !== null && newWidth !== undefined && newWidth < 1e-6)
        newWidth = this.data.width() === 0 ? this.data.width() : 1;
    return this.data.width.call(this.data, newWidth);
};

LineInteractionModel.prototype.length = function() {
    return this.data.length.apply(this.data, arguments);
};

LineInteractionModel.prototype.angle = function(newAngle) {
    // return this.data.angle.apply(this.data, arguments);
    return 0; // TODO: this is a nasty hack to keep the 9 point grid happy
};

LineInteractionModel.prototype.p1 = function() {
    return this.data.p1.apply(this.data, arguments);
};

LineInteractionModel.prototype.p2 = function() {
    return this.data.p2.apply(this.data, arguments);
};
